import './product-details-modal.scss';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'components/modal';
import { Dispatch, ReactNode, SetStateAction } from 'react';

function ProductDetailsModal({
    open,
    setOpen,
    name,
    description,
    price
} : {
    open: boolean,
    setOpen: Dispatch<SetStateAction<boolean>>,
    name: string,
    description: string,
    price: number
}) {
    return (
        <Modal open={open} setOpen={setOpen} id="product-details-modal">
            <ModalHeader>Product Details</ModalHeader>
            <ModalBody>
                <div className="section">
                    <p className="title">Name</p>
                    <p className="value">{name}</p>
                </div>
                <div className="section">
                    <p className="title">Description</p>
                    <p className="value" dangerouslySetInnerHTML={{__html: description}}></p>
                </div>
                <div className="section">
                    <p className="title">Price</p>
                    <p className="value">R {price && price.toFixed(2)}</p>
                </div>
            </ModalBody>
            <ModalFooter>
                <div className="button-group">
                    <button className="btn-cancel" onClick={() => setOpen(false)}>Cancel</button>
                    <button className="btn-add">Add</button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default ProductDetailsModal;